import React from 'react';
import Select from 'react-select';

/**
 * Generic react-select multi picker for a flat list of `{id, name}` items.
 *
 * Merges `selectedIds` that aren't present in `items` so a previously-saved
 * id (e.g. from a re-assigned employer) still renders rather than silently
 * disappearing.
 *
 * Props:
 *   items         — full option list as `{id, name}[]` (defaults to [])
 *   selectedIds   — currently-selected ids (defaults to [])
 *   onChange      — called with the new `ids[]` when the selection changes
 *   isDisabled    — passes through to Select
 *   name          — Select's form name / select id (defaults to 'assignment')
 */
class AssignmentMultiSelect extends React.Component {
  render() {
    const items = this.props.items || [];
    const selectedIds = this.props.selectedIds || [];
    const isDisabled = this.props.isDisabled || false;
    const name = this.props.name || 'assignment';

    // Merge previously-selected ids that may not be in the current items list
    // (e.g., after employer reassignment) so they still render.
    const mergedOptions = [...items];
    selectedIds.forEach((id) => {
      if (!mergedOptions.some((item) => item.id === id)) {
        mergedOptions.push({ id, name: String(id) });
      }
    });

    const selectOptions = mergedOptions.map((item) => ({
      value: item.id,
      label: item.name,
    }));

    const selectedOptions = selectOptions.filter((opt) =>
      selectedIds.includes(opt.value),
    );

    const allSelectableIds = items.map((item) => item.id);
    const allSelected =
      allSelectableIds.length > 0 &&
      allSelectableIds.every((id) => selectedIds.includes(id));

    const handleSelectAll = (event) => {
      event.preventDefault();
      this.props.onChange(allSelectableIds);
    };

    const handleClear = (event) => {
      event.preventDefault();
      this.props.onChange([]);
    };

    return (
      <>
        {!isDisabled && items.length > 0 && (
          <div className="d-flex justify-content-end mb-1" style={{ gap: '0.75rem' }}>
            <button
              type="button"
              className="btn btn-link btn-sm p-0"
              onClick={handleSelectAll}
              disabled={allSelected}>
              Select all ({items.length})
            </button>
            <button
              type="button"
              className="btn btn-link btn-sm p-0 text-muted"
              onClick={handleClear}
              disabled={selectedIds.length === 0}>
              Clear
            </button>
          </div>
        )}
        <Select
          isMulti
          isSearchable
          name={name}
          isDisabled={isDisabled}
          onChange={(selected) => {
            const ids = selected ? selected.map((s) => s.value) : [];
            this.props.onChange(ids);
          }}
          value={selectedOptions}
          options={selectOptions}
        />
      </>
    );
  }
}

export default AssignmentMultiSelect;
